import React, { useEffect, useRef, useState } from "react";
import { Box, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { getImageInfo } from "../../Services/commonService";

function ImageDetailModal({ open, handleOpen, imageName }) {
  const [imageDetail, setImageDetail] = useState(null);
  const timerRef = useRef(null);

  const handleDetail = async (imageName) => {
    setImageDetail(null); // reset
    if (!imageName) return;

    try {
      let type = "1";
      if (imageName?.substring(0, 2) === "VD") type = "2";
      const resp = await getImageInfo({ name: imageName, type });
      setImageDetail(resp || null);
    } catch (err) {
      console.error("Error fetching image info:", err);
      setImageDetail(null);
    }
  };

  useEffect(() => {
    if (imageName) handleDetail(imageName);
    else setImageDetail(null);
  }, [imageName]);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (open && !imageDetail) {
      timerRef.current = setTimeout(() => {
        console.log("❌ Auto-closing dialog: no image details found");
        handleOpen(false);
      }, 4000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [open, imageDetail, handleOpen]);

  const handleManualClose = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    handleOpen(false);
    setTimeout(() => setImageDetail(null), 100);
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={handleManualClose}
      aria-labelledby="image-detail-dialog"
    >
      {imageDetail && (
        <DialogTitle
          id="image-detail-dialog"
          padding={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          Image Preview
          <Close sx={{ cursor: "pointer" }} onClick={handleManualClose} />
        </DialogTitle>
      )}

      <DialogContent>
        <Box>
          {!imageDetail ? (
            <Typography>Loading...</Typography>
          ) : (
            <Box>
              <img
                src={imageDetail?.url}
                alt={imageDetail?.Name || imageName}
                style={{
                  maxHeight: 600,
                  maxWidth: "100%",
                  marginBottom: -8,
                }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#000000db",
                  padding: 10,
                }}
              >
                <Typography sx={{ color: "#fff" }}>{imageDetail?.contributor}</Typography>
                <Typography sx={{ color: "#fff" }}>{imageDetail?.Name}</Typography>
              </div>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ImageDetailModal;
